module.exports = __webpack_public_path__ + "static/img/harvest-button.c0435a8d.png";